import React, { useEffect, useRef, useState } from 'react';
import storage from 'utils/storage';
import { VerificationCodeInputField } from 'components/Form';
import { Button, Spinner } from 'components/Elements';
import { useNavigate } from 'react-router-dom';
import { emailOTPSetup } from '../api/emailOTPSetup';
import { verifyEmailOTPSetup } from '../api/emailOTPSetup_verify';
import Cookies from 'js-cookie';

export const EmailOTPSetupForm = ({ onSuccess }) => {
  const [verificationCode, setVerificationCode] = useState(
    new Array(6).fill('')
  );
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [success, setSuccess] = useState(false);

  const hasSentEmail = useRef(false); // 🛡️ Prevent double send
  const navigate = useNavigate();
  const { user } = storage.getTempData();

  useEffect(() => {
    const sendEmailCode = async () => {
      if (hasSentEmail.current) return; // Prevent multiple requests
      hasSentEmail.current = true;

      try {
        setLoading(true);
        await emailOTPSetup();
      } catch (err) {
        setError('Failed to send email verification code. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    sendEmailCode();
  }, []);

  const handleVerify = async () => {
    setVerifying(true);
    setError('');

    const fcmToken = storage.getFCMToken();

    try {
      await verifyEmailOTPSetup({
        email: user.email,
        code: verificationCode,
        fcmToken,
      });
      setSuccess(true);
      Cookies.set('authentication_level_email', 'pass');
      navigate('/auth/security/setup-required');
    } catch (err) {
      console.log(err);
      setError('Invalid verification code. Please try again.');
    } finally {
      setVerifying(false);
    }
  };

  const handleRefresh = async () => {
    setLoading(true);
    setError('');
    try {
      await emailOTPSetup();
      setSuccess(false);
    } catch (err) {
      setError('Failed to resend email verification code. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      {loading ? (
        <Spinner />
      ) : (
        <>
          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-100 mb-2">
              A 6-digit code has been sent to your email. Please enter it below
              to complete email-based two-factor authentication setup.
            </label>
            <div className="flex space-x-2 justify-start">
              <VerificationCodeInputField
                length={6}
                onChange={(code) => setVerificationCode(code)}
              />
            </div>
          </div>
          {success && (
            <p className="text-green-500 text-center mt-3">
              Verification successful!
            </p>
          )}
          {error && <p className="text-red-500 text-center mt-3">{error}</p>}
          <Button
            onClick={handleVerify}
            disabled={verifying || verificationCode.length === 0}
            variant="glass"
            className="mt-4 w-full"
          >
            {verifying ? 'Verifying...' : 'Verify'}
          </Button>
          <button onClick={handleRefresh} className="mt-4 w-full text-white">
            Resend Code
          </button>
        </>
      )}
    </div>
  );
};
